import { render, staticRenderFns } from "./ConfirmComponent.vue?vue&type=template&id=3505049d&scoped=true"
import script from "./ConfirmComponent.vue?vue&type=script&lang=ts"
export * from "./ConfirmComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3505049d",
  null
  
)

export default component.exports